import organizationRouting from './partner/org-routing';
import serviceRouting from './service/service-routing';
import RouterView from '@/components/router-view.vue';
import eCommerceRouting from './e-commerce/commerce-routing';
export default [
  {
    path: 'partner',
    component: RouterView,
    redirect: '/socialized-service/partner/partner-list',
    name: 'partner',
    meta: {
      title: '社会化服务'
    },
    children: organizationRouting
  },
  {
    path: 'service',
    component: RouterView,
    redirect: '/socialized-service/service/list?type=001',
    meta: {
      title: '社会化服务'
    },
    children: serviceRouting
  },
  {
    path: 'e-commerce',
    component: RouterView,
    redirect: '/socialized-service/e-commerce/list',
    meta: {
      title: '农资服务'
    },
    children: eCommerceRouting
  }
];
